import React from "react";
import { ListGroup} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faMinusCircle} from "@fortawesome/free-solid-svg-icons";
import TextSlider from "../textSlider";


export default function RulesEditVolumeEntry(props) {
    function setPoints(val){
        props.data.grading = val;
        props.cb(props.data);
    }
    function setPercentage(val) {
        props.data.percentage = val;
        props.cb(props.data);
    }

    return (
                <ListGroup.Item className="d-flex justify-content-between align-items-start">
                    <span>
                        Penalise grade by
                    <TextSlider
                        min={0}
                        max={100}
                        value={props.data.grading}
                        onChange={setPoints}
                        display={(value) => <span> ( {value} ) points</span>}
                    />
                    if there is a
                    <TextSlider
                        min={0}
                        max={100}
                        rate={0.5}
                        value={props.data.percentage}
                        onChange={setPercentage}
                        display={(value) => <span>( {value} ) %</span>}
                    />
                    difference
                    </span>

                    <button onClick={() => props.cb(null)} className="ms-2 btn btn-link text-danger">
                        <FontAwesomeIcon className="pe-auto" icon={faMinusCircle} />
                    </button>
                </ListGroup.Item>


    )
}